import { Button } from 'common/components';
import { CommunityCreationSuccess } from 'community/components/CommunityCreationSuccess';
import { setShowCommunityCreationSuccessModal } from 'community/state/communitySlice';
import { selectShowCommunityCreationSuccessModal } from 'community/state/selectors';
import { Routes } from 'modules/router';
import { useAppDispatch, useAppSelector } from 'store';

export const CommunityCreationSuccessContainer = () => {
  const dispatch = useAppDispatch();
  const showSuccess = useAppSelector(selectShowCommunityCreationSuccessModal);

  const closeModal = () => dispatch(setShowCommunityCreationSuccessModal(false));

  return (
    <CommunityCreationSuccess isOpen={showSuccess}>
      <Button variant="outlined" onClick={closeModal}>
        Continue
      </Button>
      <Button variant="contained" color="primary" href={Routes.EventWizard} onClick={closeModal}>
        Create an Event
      </Button>
    </CommunityCreationSuccess>
  );
};
